export class EventHandlerApi {
  #START_EVENT_HANDLER = 'StartEventHandler'
  #AFTER_SIGNIN_EVENT_HANDLER = 'AfterSignInEventHandler'
  constructor(vue, store) {
    this.addEventsListener(vue, store)
  }

  // Добавление слушателя
  addEventsListener(vue, store) {
    let appModel = store.getters.appModel
    let appEventHandlers = appModel.UserModel?.Settings?.EventHandlers ?? appModel.Settings?.EventHandlers
    if (!appEventHandlers) {
      return
    }

    window.addEventListener(this.#START_EVENT_HANDLER, () => {
      if (appEventHandlers.StartEventHandlerValue) {
        vue.$jsActionsRunner.callJsActions(appEventHandlers.StartEventHandlerValue, null, null)
      }
    })

    window.addEventListener(this.#AFTER_SIGNIN_EVENT_HANDLER, () => {
      if (appEventHandlers.AfterSignInEventHandlerValue) {
        vue.$jsActionsRunner.callJsActions(appEventHandlers.AfterSignInEventHandlerValue, null, null)
      }
    })
  }

  // Вызов события
  callStartEventHandler() {
    let applicationRoot = document.getElementById('applicationRoot')

    if (!applicationRoot) {
      return
    }

    let startEventHandler = new Event(this.#START_EVENT_HANDLER, { bubbles: true })
    applicationRoot.dispatchEvent(startEventHandler)
  }

  // Вызов события после авторизации
  callAfterSignInEventHandler() {
    let applicationRoot = document.getElementById('applicationRoot')

    if (!applicationRoot) {
      return
    }

    let afterSignInEventHandler = new Event(this.#AFTER_SIGNIN_EVENT_HANDLER, { bubbles: true })
    applicationRoot.dispatchEvent(afterSignInEventHandler)
  }
}